<script>
import RPersonImg from '../components/RPersonImg.vue'

export default {
  components: { RPersonImg },
  props: {
    person: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: () => 'normal'
    }
  },
  computed: {
    headerHeight() {
      if (this.type == 'small') return 'h-60 lg:h-96'
      if (this.type == 'medium') return 'h-60 lg:h-105'
      return 'h-60 lg:h-140'
    }
  }
}
</script>

<template>
  <router-link :to="`${$route.fullPath}/${person._id}`">
    <article class="flex flex-col">
      <header class="overflow-hidden rounded-lg w-full" :class="[headerHeight]">
        <RPersonImg
          class="w-full h-full object-cover"
          :src="
            person.img.fileKey
              ? `https://ucarecdn.com/${person.img.fileKey}/-/grayscale/image.png`
              : null
          "
          :alt="person.name"
        />
      </header>
      <footer class="w-full mt-3 text-center font-sans">
        <h2 class="text-lg2">{{ person.name }}</h2>
        <h6 class="text-primary text-lg">{{ person.position }}</h6>
      </footer>
    </article>
  </router-link>
</template>
